import { FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { Message } from "primereact/message";

import { useStore } from "../../../stores/StoreContext";

import "./GlobalErrorMessages.scss";

interface IGlobalErrorMessagesProps {
  children?: (content: ReactNode) => ReactNode;
}

const RawGlobalErrorMessages: FunctionComponent<IGlobalErrorMessagesProps> = ({
  children,
}: IGlobalErrorMessagesProps) => {
  const { t } = useTranslation();
  const { globalErrorsStore } = useStore();

  if (!globalErrorsStore.hasErrors) {
    return;
  }

  children ??= content => content;

  return children(
    <div className="global-errors">
      {globalErrorsStore.currentErrors.map(({ key, data }) => (
        <Message key={key} severity="error" className="global-error" text={t(key, data) as string} />
      ))}
    </div>,
  );
};

export const GlobalErrorMessages = observer(RawGlobalErrorMessages);
